// removed by extract-text-webpack-plugin
module.exports = {"Item":"Item___3LHhP","loading":"loading___3vP7Q","container":"container___3C7jd","row":"row___1LaVA","column":"column___31F2s","img1":"img1___L0aof","img2":"img2___3qCRF","btn":"btn___1ckZH","GUIEditor":"GUIEditor___1fENI","vars":"vars___3WHYZ","list":"list___3ewpz","containerStandAlone":"containerStandAlone___3xKPs","ItemStandAlone":"ItemStandAlone___5taLM"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Item/styles.scss
// module id = 334
// module chunks = 0